import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BFormCheckbox } from "bootstrap-vue";
import { computed } from "vue";
import { findDescendants, flattenValues, getAllValues } from "./utilities";
import FormDrilldownList from "./FormDrilldownList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDrilldown',
    props: {
        id: null,
        value: { default: null },
        options: null,
        multiple: { type: Boolean, default: true },
        showIcons: { type: Boolean, default: false }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const hasOptions = computed(() => {
            return props.options.length > 0;
        });
        // Determine all available values
        const allValues = computed(() => {
            return getAllValues(props.options);
        });
        // Determine current value
        const currentValue = computed(() => {
            if (props.value === null || props.value === "") {
                return [];
            }
            else if (Array.isArray(props.value)) {
                return props.value;
            }
            else {
                return [props.value];
            }
        });
        // Determine if select all is checked
        const selectAllChecked = computed(() => {
            return allValues.value.length === currentValue.value.length;
        });
        // Determine if select all state undetermined
        const selectAllIndeterminate = computed(() => {
            return ![0, allValues.value.length].includes(currentValue.value.length);
        });
        // Handle click on individual check/radio element
        function handleClick(clickedElement, value) {
            if (props.multiple) {
                const clickedElements = addDescendants(props.options, clickedElement);
                const selectedElements = setElementValues(currentValue.value, clickedElements, value);
                if (selectedElements.length === 0) {
                    emit("input", null);
                }
                else {
                    emit("input", selectedElements);
                }
            }
            else {
                emit("input", clickedElement);
            }
        }
        // Handle click on select all checkbox to either select or unselect all values
        function onSelectAll(selected) {
            emit("input", selected ? allValues.value : null);
        }
        // Returns the descendant values and the selected/parent value (regardless of unselected or selected)
        function addDescendants(selectOptions, selectedValue) {
            const descendants = findDescendants(selectOptions, selectedValue);
            const allValues = flattenValues(descendants);
            allValues.unshift(selectedValue);
            return allValues;
        }
        function setElementValues(oldArray, newArray, value) {
            if (value) {
                return Array.from(new Set([...oldArray, ...newArray]));
            }
            else {
                const newSet = new Set(newArray);
                return oldArray.filter((item) => !newSet.has(item));
            }
        }
        return { __sfc: true, props, emit, hasOptions, allValues, currentValue, selectAllChecked, selectAllIndeterminate, handleClick, onSelectAll, addDescendants, setElementValues, BAlert, BFormCheckbox, FormDrilldownList };
    }
});
